<div>
  <div class="modal-header border-0 d-flex m-0">
    <h5 class="modal-title text-dark" *ngIf="user">{{'userManagement.EDIT USER' | translate}}</h5>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true" (click)="closeModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x text-dark" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </span>
    </button>
  </div>
</div>
<div class="modal-body pr-0">
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.Username' | translate}}<span class="text-star">*</span></label>
    <!-- <input  [(ngModel)]="data.userName" name="userName" placeholder="" style="width: 60%" -->
    <input  disabled='true' [(ngModel)]="data.userName" name="userName" placeholder="" style="width: 60%"
        type="text" id="#13343" >
  </div>
  <!-- <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.First Name' | translate}}<span class="text-star">*</span></label>
    <input [(ngModel)]="data.name"  (change)="isEmpty(data['name'])" (keyup)="isEmpty(data['name'])" name="firstName" placeholder="" style="width: 60%"
        type="text" id="#13343" [ngClass]="empty ? 'is-invalid' : ''" >
        <div class="invalid-feedback">"Name should not be empty"</div>
  </div> -->
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.First Name' | translate}}<span class="text-star">*</span></label>
    <input [(ngModel)]="data.firstName"  (change)="isEmpty(data['firstName'])" (keyup)="isEmpty(data['firstName'])" name="firstName" placeholder="" style="width: 60%"
        type="text" id="#13343" [ngClass]="empty ? 'is-invalid' : ''" >
        <div class="invalid-feedback">"Name should not be empty"</div>
  </div>
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.Last Name' | translate}}<span class="text-star">*</span></label>
    <input  [(ngModel)]="data.lastName"  (change)="isEmpty(data['lastName'])" (keyup)="isEmpty(data['lastName'])" name="lastName" placeholder="" style="width: 60%"
        type="text" id="#13343" [ngClass]="empty ? 'is-invalid' : ''">
        <div class="invalid-feedback">"Name should not be empty"</div>
  </div>
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.Mobile Number' | translate}}<span class="text-star">*</span></label>
    <input  [(ngModel)]="data['mobileNo']" (keypress)="keyPress($event,data['mobileNo'])"
    (keyup)="validateContact(data['mobileNo'])" maxlength=10 
    (change)="validateContact(data['mobileNo'])" [ngClass]="status ? 'is-invalid' : ''"
     title="Please enter exactly 10 digits" 
     placeholder="" style="width: 60%;"   type="text"
     >
        <div class="invalid-feedback">"Contact no. Should Be Valid"</div>
  </div>
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.Email' | translate}}<span class="text-star">*</span></label>
    <input  [(ngModel)]="data['email']" name="email" placeholder="" style="width: 60%" type="text" id="#13343" 
    (keyup)="validateEmail(data['email'])"
         type="text" (change)="validateEmail(data['email'])" [ngClass]="emailinvalid ? 'is-invalid' : ''" > 
        <div class="invalid-feedback">"Emailid Should Valid"</div>
  </div>
  <div class="form-group row" style="padding-left: 0px; padding-right:0px"> 
    <label style="width:30%" >{{'userManagement.role' | translate}}<span class="text-star">*</span></label>
    <input  disabled='true' [(ngModel)]="data.role" name="role" placeholder="" style="width: 60%"
        type="text" id="#13343" >
  </div>
  <div class="col-sm-12" style="margin-left: 38%;">
  <button [disabled]="(emailinvalid || status || empty)"  type="submit"
  (click)="submit()" class="btn btn-info">{{'submitdata.save' | translate}}</button>
  </div>

</div>